import type { CSSProperties } from "react";
import { useEffect, useState } from "react";

import { sx } from "../style";

function hashHue(str = ""): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) % 360;
  return h;
}
function initials(name = ""): string {
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();
}

export interface AvatarProps {
  name?: string;
  src?: string;
  size?: number;
  square?: boolean;
  style?: CSSProperties;
}

/** User avatar with initials fallback. Cool brand-tinted hues. */
export function Avatar({ name = "", src, size = 32, square = false, style }: AvatarProps) {
  const hue = hashHue(name);
  const dim = size;
  const [errored, setErrored] = useState(false);
  // Скидаємо прапорець помилки при зміні src — інакше перевикористаний DOM-вузол
  // (той самий компонент, інший user id у списку) застрягне на «зламаному фото».
  useEffect(() => setErrored(false), [src]);
  const showImg = Boolean(src) && !errored;
  return (
    <span
      style={sx({
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: dim,
        height: dim,
        flex: "none",
        borderRadius: square ? "var(--radius-md)" : "50%",
        background: showImg ? "var(--neutral-100)" : `hsl(${hue} 42% 90%)`,
        color: `hsl(${hue} 45% 32%)`,
        overflow: "hidden",
        fontSize: Math.round(dim * 0.4),
        fontWeight: "var(--fw-semibold)",
        fontFamily: "var(--font-sans)",
        ...style,
      })}
    >
      {showImg ? (
        <img
          src={src}
          alt={name}
          onError={() => setErrored(true)}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        initials(name)
      )}
    </span>
  );
}
